
import EntityConstants from "../../../configs/EntityConstants";
import PermissionConstants from "../../../configs/PermissionConstants";
import LocationUpload from "./LocationUpload";
import StudentUpload from "./StudentUpload";



const Config = [
    {
        title: "Student CSV Download & Upload",
        componentName: "Students",
        downloadPermission: PermissionConstants.STUDENT_CSV_DOWNLOAD,
        uploadPermission: PermissionConstants.STUDENT_CSV_UPLOAD,
        entityApi: EntityConstants.CSV_STUDENT_DOWNLOAD,
        fileName: "Students.csv",
        component: <StudentUpload />
    },
    {
        title: "Area CSV Download & Upload",
        componentName: "Areas",
        downloadPermission: PermissionConstants.AREA_CSV_DOWNLOAD,
        uploadPermission: PermissionConstants.AREA_CSV_UPLOAD,
        entityApi: EntityConstants.CSV_AREA_DOWNLOAD,
        fileName: "Areas.csv",
        component: <LocationUpload />
    },
]

export default Config;